import http from "./httpService";
//import {setJwt, getJwt, getDataJwt} from "./httpService";

//import { apiURL } from "../config.json";

const apiEndPoint = `/ControlAcceso/loginSIAF`;

const login = async (data) => {
    try {
        let CA = { "pin": data };
        let response = await http.post(apiEndPoint, CA);
        
        if (response.status === 200 && response.data.token && response.data.expiration) {
            localStorage.setItem("access_token", response.data.token);
            localStorage.setItem("expire_at", response.data.expiration);
        }
    } catch(e) {
        return 400;
    }
}

const logout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("expire_at");
}

export default { login, logout }